import { render, staticRenderFns } from "./WeekSearch.vue?vue&type=template&id=60f94666&"
import script from "./WeekSearch.vue?vue&type=script&lang=ts&"
export * from "./WeekSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports